import { FaArrowRight } from 'react-icons/fa'
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import school from '../../assets/school.jpg';

const School = () => {
    return (
        <div className="para-home">
            <div className="container school-cont">
                <div className="row">
                    <div className="col s12 m6 l5  hide-on-small-only">
                        <img src={school} alt="Life Long Polytechnic entrance" className="responsive-img" />
                    </div>
                    <div className="col s12 m6 l6 offset-l1">
                        <p className="white-text school small-text">Life Long Polytechnic (LLP) is a first privately owned Polytechnic located in Harare Metropolitan Province in Zimbabwe. Born from Life Long Education College, LLP is a fast growing visionary institute of learning aiming to be an internationally top ranking centre of excellence in spearheading research, innovativeness, and entrepreneurship through the study of commerce and STEM Education.</p>
                        <motion.div 
                            className="make-inline" 
                            whileHover={{ scale: 1.1, originX: 'center'}}
                            transition={{ type: 'spring', stiffness: 600, damping: 3}}
                        >     
                        <Link
                            to="/about" className="button is-rounded main-color mt-5 border-none hide-on-med-only hide-on-tiny"
                           
                        >
                            <span className="icon">
                                <FaArrowRight color="white"/>
                            </span>
                            <span className="white-text">Read More</span>
                        </Link>
                        </motion.div>
                    </div>
                </div>
            </div>
        </div>
     );
}
 
export default School;